"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const faqs = [{
    question: "Jakie roszczenia przysługują mi po wypadku komunikacyjnym?",
    answer: "Po wypadku komunikacyjnym możesz dochodzić odszkodowania za szkody materialne (np. uszkodzenie pojazdu) oraz zadośćuczynienia za doznaną krzywdę, ból, cierpienie i pogorszenie jakości życia. Każda sprawa wymaga indywidualnej analizy dokumentacji i oceny odpowiedzialności sprawcy."
  }, {
    question: "Czy mogę dochodzić odszkodowania po wypadku przy pracy?",
    answer: "Tak, jeśli doznałeś obrażeń w wyniku wypadku przy pracy, możesz dochodzić roszczeń od pracodawcy lub ubezpieczyciela. Analizujemy podstawy prawne odpowiedzialności pracodawcy oraz wszystkie okoliczności zdarzenia, aby maksymalnie zabezpieczyć Twoje interesy."
  }, {
    question: "Jakie kroki należy podjąć po wypadku rolniczym?",
    answer: "Po wypadku rolniczym zaleca się zgromadzenie dokumentacji medycznej, zgłoszenie zdarzenia do KRUS oraz skonsultowanie sprawy z prawnikiem. Pomagamy w ocenie odpowiedzialności ubezpieczeniowej i reprezentujemy poszkodowanych w dochodzeniu należnych świadczeń."
  }, {
    question: "Czy można dochodzić roszczeń po śmierci osoby bliskiej?",
    answer: "Tak, członkowie rodziny osoby zmarłej w wyniku wypadku lub innego zdarzenia objętego odpowiedzialnością cywilną sprawcy mogą dochodzić roszczeń, w tym zadośćuczynienia za ból i cierpienie oraz odszkodowania za pogorszenie sytuacji życiowej. Prowadzimy takie sprawy z należytą wrażliwością i profesjonalizmem."
  }, {
    question: "Co zrobić w przypadku błędu medycznego?",
    answer: "W przypadku podejrzenia błędu medycznego należy zgromadzić dokumentację medyczną i skonsultować sprawę z prawnikiem. Prowadzimy szczegółową analizę dokumentacji, oceniamy podstawy prawne odpowiedzialności oraz reprezentujemy poszkodowanych w dochodzeniu roszczeń odszkodowawczych i zadośćuczynień."
  }, {
    question: "Jak przebiega proces dochodzenia odszkodowania?",
    answer: "Proces rozpoczyna się od analizy Twojej sprawy i zgromadzenia dokumentacji. Następnie kontaktujemy się z ubezpieczycielem sprawcy, przedstawiając roszczenia. Jeśli nie dojdzie do polubownego rozwiązania, reprezentujemy Cię przed sądem. Zapewniamy wsparcie na każdym etapie postępowania."
  }];
  return <section id="najczęściej-zadawane-pytania" ref={ref} className={`bg-background py-space-xl transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="mx-auto max-w-3xl px-4">
        <h2 className="mb-space-lg text-center">
          Najczęściej zadawane pytania
        </h2>

        <Accordion type="single" collapsible className="w-full space-y-0">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-border py-space-sm last:border-b-0">
              <AccordionTrigger className="text-left font-sans text-lg font-semibold hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}